if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"sdm-app","remotes":[{"alias":"ldpViewResolverSdm","name":"ldpViewResolverSdm","entry":"https://assets-platform.loblaws.ca/ldp-core-web-prod/production/ldp/view-resolver-sdm/latest/dist/remoteEntry.js","shareScope":"default"},{"alias":"beautyFrontendPlp","name":"beautyFrontendPlp","entry":"https://assets.shoppersdrugmart.ca/bb-react-frontend/production-sdui/latest/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(1(99[89]|034|087|444|791)|5(052|221|482)|6(325|473|940)|2815|797|8122|9276|9839)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}